import { ServerStorage } from "@/constants/app-data";
import { useAuth } from "@/layouts/AuthContext";
import { UserContext } from "@/contexts/user-context";
import { Heart, ShoppingCart, User } from "lucide-react";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

export default function NavbarIcons() {
    const { lang } = useParams();
    const baseRoute = `/${lang || "id"}`;
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { isAuthenticated, user } = useAuth();
    const { cart, favorite } = useContext(UserContext);
    const avatar = user?.photo
        ? `${ServerStorage}${user.photo}`
        : user?.googlePhoto
          ? user.googlePhoto
          : null;

    return (
        <>
            <div
                onClick={() =>
                    navigate(
                        `${baseRoute}/${isAuthenticated ? "profile" : "login"}`,
                    )
                }
                className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-300 hover:text-gold dark:hover:text-gold cursor-pointer">
                {isAuthenticated ? (
                    <>
                        {avatar ? (
                            <img
                                src={avatar}
                                alt=""
                                width="32"
                                height="32"
                                className="w-8 h-8 rounded-full object-cover p-0.5 border border-gold/40"
                            />
                        ) : (
                            <User size={22} />
                        )}
                        <span className="hidden lg:inline font-medium">
                            {user?.name && user.name.length > 14
                                ? `${user.name.substring(0, 14)}...`
                                : user?.name}
                        </span>
                    </>
                ) : (
                    <>
                        <User size={22} />
                        <span className="hidden lg:inline">
                            {t("nav.login")}
                        </span>
                    </>
                )}
            </div>
            <div
                onClick={() => navigate(`${baseRoute}/favorites`)}
                className="flex flex-col items-center gap-0.5 text-gray-600 dark:text-gray-300 hover:text-gold dark:hover:text-gold cursor-pointer relative">
                <Heart size={22} />
                <span className="text-[10px] hidden sm:block">
                    {t("nav.fav")}
                </span>
                <span className="absolute -top-1.5 -right-2 bg-red-500 text-white text-[9px] font-bold w-4 h-4 rounded-full flex items-center justify-center">
                    {favorite?.length || 0}
                </span>
            </div>
            <div
                onClick={() => navigate(`${baseRoute}/cart`)}
                className="flex flex-col items-center gap-0.5 text-gray-600 dark:text-gray-300 hover:text-gold dark:hover:text-gold cursor-pointer relative">
                <ShoppingCart size={22} />
                <span className="text-[10px] hidden sm:block">
                    {t("nav.cart")}
                </span>
                <span className="absolute -top-1.5 -right-2 bg-gold text-white text-[9px] font-bold w-4 h-4 rounded-full flex items-center justify-center">
                    {cart?.length || 0}
                </span>
            </div>
        </>
    );
}
